<template>
  <div class="main__marketplace">
    <loading v-if="isUniversalLoading" />
    <navbar />
    <market-place />
  </div>
</template>

<script>
import MarketPlace from "./MarketPlace.vue";
import Navbar from "@/components/Navbar.vue";
import Loading from "@/components/Loading.vue";
export default {
  components: { Loading, Navbar, MarketPlace },
  computed: {
    isUniversalLoading() {
      return this.$store.state.modals.isUniversalLoading;
    },
  },
};
</script>

<style lang="scss" scoped>
.main__marketplace {
  height: 100vh;
  overflow: hidden;
}
</style>
